var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"500px"},attrs:{"id":"chartDeliveryUnitRegion"}})
}
var staticRenderFns = []

export { render, staticRenderFns }